import React from "react";
import { Box, CardMedia } from "@mui/material";

interface ImageDisplayProps {
  imageUrl?: string;
  placeholderUrl?: string;
  alt: string;
  aspectRatio?: number;
  width?: string | object;
  borderRadius?: number;
  objectFit?: "contain" | "cover" | "fill" | "none" | "scale-down";
  backgroundColor?: string;
  sx?: object;
}

export const ImageDisplay: React.FC<ImageDisplayProps> = ({
  imageUrl,
  placeholderUrl,
  alt,
  aspectRatio = 2,
  width = "100%",
  borderRadius = 1,
  objectFit = "contain",
  backgroundColor = "transparent",
  sx = {},
}) => {
  return (
    <Box
      sx={{
        width: width,
        position: "relative",
        aspectRatio: `${aspectRatio}/1`,
        overflow: "hidden",
        borderRadius: borderRadius,
        backgroundColor: backgroundColor,
        ...sx,
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: objectFit,
          objectPosition: "center",
          display: "block",
        }}
        image={imageUrl || placeholderUrl}
        alt={alt}
      />
    </Box>
  );
};

export const CardImageDisplay: React.FC<Omit<ImageDisplayProps, "width">> = (
  props
) => {
  return <ImageDisplay {...props} width={{ xs: "100%", md: "33%" }} />;
};

export const FullWidthImageDisplay: React.FC<
  Omit<ImageDisplayProps, "width">
> = (props) => {
  return <ImageDisplay {...props} width="100%" />;
};

export const ThumbnailImageDisplay: React.FC<
  Omit<ImageDisplayProps, "width" | "aspectRatio">
> = (props) => {
  return (
    <ImageDisplay
      {...props}
      width={{ xs: "100%", sm: "200px" }}
      aspectRatio={1}
    />
  );
};
